import Query from "./query";

class GetUserPosition extends Query {
    constructor() {
        super("getUserPosition");
    }

    async execute(params) {
        const position = iq3Camera.getConfigurationWorld().position;
        return position.toArray();
    }
}

export default GetUserPosition;